<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';

    const localize = getLocalization();
</script>

<div>
    {localize(/* @kp-localization loan.ext.EVypujckaJeDostupnaProTatoZarizeni */ 'loan.ext.EVypujckaJeDostupnaProTatoZarizeni')}
    <ul>
        <li>
            {localize(/* @kp-localization loan.ext.ZarizeniSAndroidem */ 'loan.ext.ZarizeniSAndroidem')}
            (<a href="https://play.google.com/store/apps/details?id=cz.albatrosmedia.palmknihy&hl=cs&gl=US" target="_blank">
            {localize(/* @kp-localization loan.ext.pomociAplikace */ 'loan.ext.pomociAplikace')}
        </a>)
        </li>
        <li>
            {localize(/* @kp-localization loan.ext.ZarizeniSIOs */ 'loan.ext.ZarizeniSIOs')}
            (<a href="https://apps.apple.com/cz/app/palmknihy/id1468124335?l=cs" target="_blank">
            {localize(/* @kp-localization loan.ext.pomociAplikace */ 'loan.ext.pomociAplikace')}
        </a>)
        </li>
        <li>
            {localize(/* @kp-localization loan.palmknihy.PalmknihyDevices */ 'loan.palmknihy.PalmknihyDevices')}
        </li>
    </ul>
</div>
